module.exports = __webpack_public_path__ + "static/media/title.f9a010a3.png";